import { httpClientOmni } from "@/libraries";

export default {

    async datatable(payload) {
        const response = await httpClientOmni.get(
            `reporting/v3/hsm`,
            {
                params: payload,
            },
        );
        return response;

        // example ouput : 
        /*
        {
            "data": [
                {
                    "id": 107,
                    "code": "SESS-20250508-107",
                    "room_id": 1085271,
                    "user_id": 1527446,
                    "bot_id": 154,
                    "bot_name": "Testing Annisa",
                    "integration_id": 1704,
                    "integration_name": "Test Annisa",
                    "channel_id": 5,
                    "channel_name": "webchat",
                    "handler": "Bot Only",
                    "status": "closed_by_bot",
                    "start_time": "2025-05-08 17:59:28",
                    "end_time": "2025-05-08 18:02:12",
                    "bot_message_count": 2,
                    "user_message_count": 2,
                    "agent_message_count": 0,
                    "category": null,
                    "sub_category": null,
                    "duration_with_bot": 164,
                    "last_updated_at": null
                },
                {
                    "id": 109,
                    "code": "SESS-20250508-109",
                    "room_id": 1085272,
                    "user_id": 1527447,
                    "bot_id": 154,
                    "bot_name": "Testing Annisa",
                    "integration_id": 1704,
                    "integration_name": "Test Annisa",
                    "channel_id": 5,
                    "channel_name": "webchat",
                    "handler": "Bot to Agent",
                    "status": "closed_by_bot",
                    "start_time": "2025-05-08 18:01:21",
                    "end_time": "2025-05-08 18:11:44",
                    "bot_message_count": 2,
                    "user_message_count": 2,
                    "agent_message_count": 0,
                    "category": null,
                    "sub_category": null,
                    "duration_with_bot": 623,
                    "last_updated_at": null
                },
                {
                    "id": 105,
                    "code": "SESS-20250508-105",
                    "room_id": 1085269,
                    "user_id": 1527444,
                    "bot_id": 293,
                    "bot_name": "bot 1",
                    "integration_id": 1663,
                    "integration_name": "test cheonsa",
                    "channel_id": 5,
                    "channel_name": "webchat",
                    "handler": "Bot Only",
                    "status": "closed_by_bot",
                    "start_time": "2025-05-08 17:51:30",
                    "end_time": "2025-05-08 17:52:31",
                    "bot_message_count": 1,
                    "user_message_count": 1,
                    "agent_message_count": 0,
                    "category": null,
                    "sub_category": null,
                    "duration_with_bot": 61,
                    "last_updated_at": null
                },
                {
                    "id": 106,
                    "code": "SESS-20250508-106",
                    "room_id": 1085270,
                    "user_id": 1527445,
                    "bot_id": 293,
                    "bot_name": "bot 1",
                    "integration_id": 1663,
                    "integration_name": "test cheonsa",
                    "channel_id": 5,
                    "channel_name": "webchat",
                    "handler": "Bot Only",
                    "status": "open",
                    "start_time": "2025-05-08 17:56:56",
                    "end_time": null,
                    "bot_message_count": 1,
                    "user_message_count": 1,
                    "agent_message_count": 0,
                    "category": null,
                    "sub_category": null,
                    "duration_with_bot": 0,
                    "last_updated_at": null
                },
                {
                    "id": 108,
                    "code": "SESS-20250508-108",
                    "room_id": 1085272,
                    "user_id": 1527447,
                    "bot_id": 154,
                    "bot_name": "Testing Annisa",
                    "integration_id": 1704,
                    "integration_name": "Test Annisa",
                    "channel_id": 5,
                    "channel_name": "webchat",
                    "handler": "Bot Only",
                    "status": "closed_by_bot",
                    "start_time": "2025-05-08 17:59:34",
                    "end_time": "2025-05-08 18:00:36",
                    "bot_message_count": 1,
                    "user_message_count": 1,
                    "agent_message_count": 0,
                    "category": null,
                    "sub_category": null,
                    "duration_with_bot": 62,
                    "last_updated_at": null
                }
            ],
            "current_page": 1,
            "page": "1",
            "per_page": "10",
            "total": 5,
            "last_page": 1,
            "total_pages": 1
        }
        */
    },

    async datatableTemplateUsage(payload) {
        const response = await httpClientOmni.get(
            `reporting/v3/hsm/template-usage`,
            {
                params: payload,
            },
        );
        return response;

        // example ouput : 
        /*
        {
            "data": [
                {
                    "template_name": "selleredu_mobil_olxrad1t",
                    "executed_by": "Aldy",
                    "template_category": "UTILITY",
                    "date": "2025-08-13",
                    "total": 124,
                    "sent": 8,
                    "failed": 48,
                    "read": 100,
                    "delivered": 92,
                    "latest_created_at": "2025-08-13 15:06:05",
                    "agentgroup": "Education, Seller Education"
                },
                {
                    "template_name": "hematmotor_asep1",
                    "executed_by": "Aldy",
                    "template_category": "UTILITY",
                    "date": "2025-08-13",
                    "total": 656,
                    "sent": 30,
                    "failed": 122,
                    "read": 670,
                    "delivered": 490,
                    "latest_created_at": "2025-08-13 13:44:22",
                    "agentgroup": "Education, Seller Education"
                }
            ],
            "current_page": 1,
            "page": "1",
            "per_page": "10",
            "total": 2,
            "last_page": 1,
            "total_pages": 1
        }
        */
    },


    async countReport(payload) {
        const response = await httpClientOmni.get(
            `reporting/v3/hsm/count`,
            {
                params: payload,
            },
        );
        return response;

        // example ouput : 
        /*
        {
	"data": {
		"total_sessions": 0,
		"bot_only_sessions": 0,
		"agent_sessions": 0,
		"bot_only_rate": "0%",
		"agent_session_rate": "100%",
		"avg_duration_with_bot": 0
	}
}
    */
    },

    async countReportTemplateUsage(payload) {
        const response = await httpClientOmni.get(
            `reporting/v3/hsm/template-usage/count`,
            {
                params: payload,
            },
        );
        return response;

        // example ouput : 
        /*
        {
	"data": {
		"total_sessions": 0,
		"bot_only_sessions": 0,
		"agent_sessions": 0,
		"bot_only_rate": "0%",
		"agent_session_rate": "100%",
		"avg_duration_with_bot": 0
	}
}
    */
    },

    async exportExcel(payload) {
        const response = await httpClientOmni.get(
            `reporting/v3/hsm/export`,
            {
                params: payload,
            },
            // {
            //     responseType: "blob",
            // }
        );
        return response;
    },
};
